import React, { useState } from 'react';
import { toast } from 'react-toastify';
import AnimatedModal from './AnimatedModal';
import BackendErrorMessage from '../../../components/BackendErrorMessage';

interface AlterarFormaModalProps {
  banca: any;
  onClose: () => void;
  onConfirm: () => void;
}

const AlterarFormaModal: React.FC<AlterarFormaModalProps> = ({ 
  banca, 
  onClose, 
  onConfirm 
}) => {
  const [loading, setLoading] = useState(false);
  const formaAtual = banca.formaRealizacao === 'REMOTO' ? 'REMOTO' : 'PRESENCIAL';
  const [formaSelecionada, setFormaSelecionada] = useState(formaAtual);

  const handleConfirm = async () => {
    if (formaSelecionada === formaAtual) {
      onClose();
      return;
    }
    setLoading(true);
    try {
      await onConfirm();
      toast.success(`Forma de realização alterada para ${formaSelecionada === 'REMOTO' ? 'Remoto' : 'Presencial'}`);
      onClose();
    } catch (error) {
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const opcoes = [
    { value: 'PRESENCIAL', label: 'Presencial', icon: '🏛️' },
    { value: 'REMOTO', label: 'Remoto', icon: '💻' },
  ];

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white', padding: '28px', borderRadius: '12px',
        width: '380px', maxWidth: '90vw',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }}>
        <h5 style={{ margin: '0 0 20px', fontWeight: '600' }}>Forma de realização</h5>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
          {opcoes.map((op) => (
            <button
              key={op.value}
              onClick={() => setFormaSelecionada(op.value)}
              style={{
                flex: 1, padding: '14px 12px', borderRadius: '8px',
                border: formaSelecionada === op.value ? '2px solid #2563eb' : '2px solid #e9ecef',
                backgroundColor: formaSelecionada === op.value ? '#eff6ff' : 'white',
                cursor: 'pointer', textAlign: 'center',
                transition: 'all 0.15s ease',
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '6px' }}>{op.icon}</div>
              <div style={{ fontSize: '14px', fontWeight: formaSelecionada === op.value ? '600' : '400', color: formaSelecionada === op.value ? '#2563eb' : '#495057' }}>
                {op.label}
              </div>
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '8px 18px', border: '1px solid #d1d5db',
              backgroundColor: 'white', borderRadius: '6px',
              cursor: 'pointer', fontSize: '14px'
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '8px 18px', backgroundColor: '#2563eb',
              color: 'white', border: 'none', borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: '500',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default AlterarFormaModal;
